// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===============================
   PREMIUM PRESENCE SECTION
=============================== */

.presence-section {
    padding: 100px 0;
    position: relative;
    overflow: hidden;
}

/* ===============================
   SECTION HEADER
=============================== */

.section-header {
    text-align: center;
    margin-bottom: 80px;
    animation: fadeInUp 0.8s ease-out;
}

.section-badge {
    display: inline-block;
    padding: 8px 20px;
    background: rgba(99, 102, 241, 0.15);
    border: 1px solid rgba(139, 92, 246, 0.4);
    border-radius: 50px;
    color: rgba(255, 255, 255, 0.95);
    font-size: 0.875rem;
    font-weight: 600;
    margin-bottom: 24px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    box-shadow: 0 4px 20px rgba(99, 102, 241, 0.2);
}

.section-title {
    font-size: clamp(2rem, 4vw, 3.5rem);
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 16px;
    letter-spacing: -0.02em;
    line-height: 1.2;
}

.gradient-text {
    background: linear-gradient(135deg, #818cf8, #c084fc, #f472b6);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* ===============================
   SCROLL CONTAINER
=============================== */

.scroll-container {
    width: 100%;
    overflow: hidden;
    margin-bottom: 28px;
    position: relative;
    padding: 12px 0;
}

.scroll-container::before,
.scroll-container::after {
    content: '';
    position: absolute;
    top: 0;
    width: 150px;
    height: 100%;
    z-index: 10;
    pointer-events: none;
}

.scroll-container::before {
    left: 0;
    background: linear-gradient(90deg, rgba(5, 7, 12, 1) 0%, rgba(5, 7, 12, 0.8) 50%, transparent 100%);
}

.scroll-container::after {
    right: 0;
    background: linear-gradient(270deg, rgba(5, 7, 12, 1) 0%, rgba(5, 7, 12, 0.8) 50%, transparent 100%);
}

/* ===============================
   SCROLL TRACK
=============================== */

.scroll-track {
    display: flex;
    gap: 28px;
    padding: 12px 0;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
}

.scroll-left {
    animation: scrollToLeft 45s linear infinite;
}

.scroll-right {
    animation: scrollToRight 45s linear infinite;
}

@keyframes scrollToLeft {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(-33.33%);
    }
}

@keyframes scrollToRight {
    0% {
        transform: translateX(-33.33%);
    }
    100% {
        transform: translateX(0);
    }
}

/* Pause on hover */
.scroll-track:hover {
    animation-play-state: paused;
}

/* ===============================
   COUNTRY CARD - HEXAGONAL
=============================== */

.country-card {
    flex-shrink: 0;
    width: 180px;
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.1), rgba(168, 85, 247, 0.05));
    border: 2px solid rgba(139, 92, 246, 0.3);
    padding: 28px 24px;
    text-align: center;
    transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
    cursor: pointer;
    clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);
}

.country-card:hover {
    transform: translateY(-12px) scale(1.08);
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.18), rgba(168, 85, 247, 0.1));
    border-color: rgba(168, 85, 247, 0.5);
    box-shadow: 
        0 20px 50px rgba(99, 102, 241, 0.3),
        0 0 40px rgba(168, 85, 247, 0.2);
}

/* ===============================
   FLAG
=============================== */

.flag-wrapper {
    width: 90px;
    height: 68px;
    margin: 0 auto 20px;
    border-radius: 10px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.08);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.4s ease;
    border: 2px solid rgba(255, 255, 255, 0.15);
}

.country-card:hover .flag-wrapper {
    transform: scale(1.15) rotate(-5deg);
    box-shadow: 
        0 12px 30px rgba(99, 102, 241, 0.4),
        0 0 20px rgba(168, 85, 247, 0.3);
    border-color: rgba(168, 85, 247, 0.5);
}

.flag-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* ===============================
   LABEL
=============================== */

.country-label {
    font-size: 0.875rem;
    font-weight: 700;
    color: rgba(255, 255, 255, 0.85);
    margin: 0;
    transition: all 0.3s ease;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.country-card:hover .country-label {
    background: linear-gradient(135deg, #818cf8, #c084fc);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

/* ===============================
   RESPONSIVE
=============================== */

@media (max-width: 768px) {
    .presence-section {
        padding: 80px 0;
    }

    .section-header {
        margin-bottom: 60px;
    }

    .scroll-container {
        margin-bottom: 24px;
    }

    .scroll-track {
        gap: 20px;
    }

    .country-card {
        width: 150px;
        padding: 24px 20px;
    }

    .flag-wrapper {
        width: 75px;
        height: 56px;
    }
}

@media (max-width: 480px) {
    .country-card {
        width: 130px;
        padding: 20px 16px;
    }

    .flag-wrapper {
        width: 65px;
        height: 49px;
        margin-bottom: 16px;
    }

    .country-label {
        font-size: 0.8125rem;
    }

    .scroll-container::before,
    .scroll-container::after {
        width: 80px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Presence.css"],"names":[],"mappings":"AAAA;;iCAEiC;;AAEjC;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;iCAEiC;;AAEjC;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,oCAAoC;IACpC,yCAAyC;IACzC,mBAAmB;IACnB,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,8CAA8C;AAClD;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,8DAA8D;IAC9D,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;;iCAEiC;;AAEjC;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,OAAO;IACP,mGAAmG;AACvG;;AAEA;IACI,QAAQ;IACR,oGAAoG;AACxG;;AAEA;;iCAEiC;;AAEjC;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,iCAAiC;IACjC,mCAAmC;AACvC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,8BAA8B;IAClC;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA,mBAAmB;AACnB;IACI,4BAA4B;AAChC;;AAEA;;iCAEiC;;AAEjC;IACI,cAAc;IACd,YAAY;IACZ,sFAAsF;IACtF,yCAAyC;IACzC,kBAAkB;IAClB,kBAAkB;IAClB,kDAAkD;IAClD,eAAe;IACf,0FAA0F;AAC9F;;AAEA;IACI,wCAAwC;IACxC,sFAAsF;IACtF,qCAAqC;IACrC;;wCAEoC;AACxC;;AAEA;;iCAEiC;;AAEjC;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,oCAAoC;IACpC;;wCAEoC;IACpC,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;;iCAEiC;;AAEjC;IACI,mBAAmB;IACnB,gBAAgB;IAChB,gCAAgC;IAChC,SAAS;IACT,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,qDAAqD;IACrD,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;;iCAEiC;;AAEjC;IACI;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;;QAEI,WAAW;IACf;AACJ","sourcesContent":["/* ===============================\n   PREMIUM PRESENCE SECTION\n=============================== */\n\n.presence-section {\n    padding: 100px 0;\n    position: relative;\n    overflow: hidden;\n}\n\n/* ===============================\n   SECTION HEADER\n=============================== */\n\n.section-header {\n    text-align: center;\n    margin-bottom: 80px;\n    animation: fadeInUp 0.8s ease-out;\n}\n\n.section-badge {\n    display: inline-block;\n    padding: 8px 20px;\n    background: rgba(99, 102, 241, 0.15);\n    border: 1px solid rgba(139, 92, 246, 0.4);\n    border-radius: 50px;\n    color: rgba(255, 255, 255, 0.95);\n    font-size: 0.875rem;\n    font-weight: 600;\n    margin-bottom: 24px;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    box-shadow: 0 4px 20px rgba(99, 102, 241, 0.2);\n}\n\n.section-title {\n    font-size: clamp(2rem, 4vw, 3.5rem);\n    font-weight: 700;\n    color: #ffffff;\n    margin-bottom: 16px;\n    letter-spacing: -0.02em;\n    line-height: 1.2;\n}\n\n.gradient-text {\n    background: linear-gradient(135deg, #818cf8, #c084fc, #f472b6);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n@keyframes fadeInUp {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* ===============================\n   SCROLL CONTAINER\n=============================== */\n\n.scroll-container {\n    width: 100%;\n    overflow: hidden;\n    margin-bottom: 28px;\n    position: relative;\n    padding: 12px 0;\n}\n\n.scroll-container::before,\n.scroll-container::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    width: 150px;\n    height: 100%;\n    z-index: 10;\n    pointer-events: none;\n}\n\n.scroll-container::before {\n    left: 0;\n    background: linear-gradient(90deg, rgba(5, 7, 12, 1) 0%, rgba(5, 7, 12, 0.8) 50%, transparent 100%);\n}\n\n.scroll-container::after {\n    right: 0;\n    background: linear-gradient(270deg, rgba(5, 7, 12, 1) 0%, rgba(5, 7, 12, 0.8) 50%, transparent 100%);\n}\n\n/* ===============================\n   SCROLL TRACK\n=============================== */\n\n.scroll-track {\n    display: flex;\n    gap: 28px;\n    padding: 12px 0;\n    animation-timing-function: linear;\n    animation-iteration-count: infinite;\n}\n\n.scroll-left {\n    animation: scrollToLeft 45s linear infinite;\n}\n\n.scroll-right {\n    animation: scrollToRight 45s linear infinite;\n}\n\n@keyframes scrollToLeft {\n    0% {\n        transform: translateX(0);\n    }\n    100% {\n        transform: translateX(-33.33%);\n    }\n}\n\n@keyframes scrollToRight {\n    0% {\n        transform: translateX(-33.33%);\n    }\n    100% {\n        transform: translateX(0);\n    }\n}\n\n/* Pause on hover */\n.scroll-track:hover {\n    animation-play-state: paused;\n}\n\n/* ===============================\n   COUNTRY CARD - HEXAGONAL\n=============================== */\n\n.country-card {\n    flex-shrink: 0;\n    width: 180px;\n    background: linear-gradient(135deg, rgba(99, 102, 241, 0.1), rgba(168, 85, 247, 0.05));\n    border: 2px solid rgba(139, 92, 246, 0.3);\n    padding: 28px 24px;\n    text-align: center;\n    transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);\n    cursor: pointer;\n    clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);\n}\n\n.country-card:hover {\n    transform: translateY(-12px) scale(1.08);\n    background: linear-gradient(135deg, rgba(99, 102, 241, 0.18), rgba(168, 85, 247, 0.1));\n    border-color: rgba(168, 85, 247, 0.5);\n    box-shadow: \n        0 20px 50px rgba(99, 102, 241, 0.3),\n        0 0 40px rgba(168, 85, 247, 0.2);\n}\n\n/* ===============================\n   FLAG\n=============================== */\n\n.flag-wrapper {\n    width: 90px;\n    height: 68px;\n    margin: 0 auto 20px;\n    border-radius: 10px;\n    overflow: hidden;\n    background: rgba(255, 255, 255, 0.08);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.4s ease;\n    border: 2px solid rgba(255, 255, 255, 0.15);\n}\n\n.country-card:hover .flag-wrapper {\n    transform: scale(1.15) rotate(-5deg);\n    box-shadow: \n        0 12px 30px rgba(99, 102, 241, 0.4),\n        0 0 20px rgba(168, 85, 247, 0.3);\n    border-color: rgba(168, 85, 247, 0.5);\n}\n\n.flag-image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n/* ===============================\n   LABEL\n=============================== */\n\n.country-label {\n    font-size: 0.875rem;\n    font-weight: 700;\n    color: rgba(255, 255, 255, 0.85);\n    margin: 0;\n    transition: all 0.3s ease;\n    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.country-card:hover .country-label {\n    background: linear-gradient(135deg, #818cf8, #c084fc);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n/* ===============================\n   RESPONSIVE\n=============================== */\n\n@media (max-width: 768px) {\n    .presence-section {\n        padding: 80px 0;\n    }\n\n    .section-header {\n        margin-bottom: 60px;\n    }\n\n    .scroll-container {\n        margin-bottom: 24px;\n    }\n\n    .scroll-track {\n        gap: 20px;\n    }\n\n    .country-card {\n        width: 150px;\n        padding: 24px 20px;\n    }\n\n    .flag-wrapper {\n        width: 75px;\n        height: 56px;\n    }\n}\n\n@media (max-width: 480px) {\n    .country-card {\n        width: 130px;\n        padding: 20px 16px;\n    }\n\n    .flag-wrapper {\n        width: 65px;\n        height: 49px;\n        margin-bottom: 16px;\n    }\n\n    .country-label {\n        font-size: 0.8125rem;\n    }\n\n    .scroll-container::before,\n    .scroll-container::after {\n        width: 80px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
